import DynamicDialog from './dynamicDialog';

export { type DynamicDialogProps } from './dynamicDialog';

export default DynamicDialog;
